export class StampingPreview {
  constructor(previewCanvas, settings) {
    this.canvas = previewCanvas;
    this.settings = settings;
    this.config = {};
  }

  init() {
    const option = document.querySelector("#stamping-option");
    this.config.option = option.value;

    option.addEventListener("change", () => {
      this.config.option = option.value;
      this.canvas.draw();
      this.updateStampingOptions();
    });

    const font = document.querySelector("#stamping-font");
    this.config.font = font.value;
    font.addEventListener("change", () => {  
      this.config.font = font.value;
      this.canvas.draw();
      this.updateStampingOptions();
    });

    const content = document.querySelector("#stamping-content");
    this.config.content = content.value;
    content.addEventListener("keyup", () => {
      let cleanValue = content.value.replace(/[^a-zA-Z0-9&. ]/gi, "");
      cleanValue = cleanValue.substr(0, this.settings.limit);
      content.value = cleanValue;
      this.config.content = cleanValue;
      this.canvas.draw();
      this.updateStampingOptions();
    });
  }
  updateStampingOptions() {
    let targetClass = document
      .querySelector(".page-wrapper")
      .getAttribute("data-stamping_class");
    if (document.querySelector("." + targetClass)) {
      if(this.config.option=='no-stamping'){
        this.config.font = '-';
        this.config.content = '-';
      }
      let configInStr = JSON.stringify(this.config);
      document.querySelector("." + targetClass + " input").value = configInStr;
    }
  }
  updateSettings(newSettings) {
    this.settings = newSettings;
  }

  disableColorlessStamping() {
    const selectDOM = document.querySelector("#stamping-option");
    const option = selectDOM.querySelector('option[value="colorless"]');
    option.disabled = true;

    if (selectDOM.value === option.getAttribute("value")) {
      const defaultValue = selectDOM
        .querySelectorAll("option")[0]
        .getAttribute("value");
      selectDOM.value = defaultValue;
      this.config.option = selectDOM.value;
      this.canvas.draw();
    }
  }

  enableColorlessStamping() {
    const selectDOM = document.querySelector("#stamping-option");
    const option = selectDOM.querySelector('option[value="colorless"]');
    option.disabled = false;
  }

  getConfig() {
    return this.config;
  }

  updateConfig(newConfig) {
    const option = document.querySelector("#stamping-option");
    option.value = newConfig.option;
    option.dispatchEvent(new Event("change"));

    const font = document.querySelector("#stamping-font");
    font.value = newConfig.font;
    font.dispatchEvent(new Event("change"));

    const content = document.querySelector("#stamping-content");
    content.value = newConfig.content;
    content.dispatchEvent(new Event("keyup"));
  }

  draw() {
    let ctx = this.canvas.ctx;

    for (let i = 0; i < this.settings.posX.length; i++) {
      let _x = this.settings.posX[i] * this.canvas.scale * this.canvas.dpr;
      let _y = this.settings.posY[i] * this.canvas.scale * this.canvas.dpr;
      let fontSize = this.settings.size * this.canvas.scale * this.canvas.dpr;
      // console.log(`Drawing at ${_x}, ${_y} with size ${fontSize}, scale ${this.canvas.scale}, dpr ${this.canvas.dpr}`);
      ctx.save();
      ctx.translate(_x, _y);

      this.gradient = ctx.createLinearGradient(0, 0, 0, fontSize);
      switch (this.config.option) {
        case "gold-foil":
          this.gradient.addColorStop(0, "rgb(165,122,16)");
          this.gradient.addColorStop(0.8, "rgb(193,151,19)");
          this.gradient.addColorStop(1, "rgb(165,122,16)");
          break;
        case "silver-foil":
          this.gradient.addColorStop(0, "rgb(170,170,170)");
          this.gradient.addColorStop(0.8, "rgb(210,210,210)");
          this.gradient.addColorStop(1, "rgb(170,170,170)");
          break;
        case "colorless":
          this.gradient.addColorStop(0, "rgba(0,0,0,0.5)");
          break;
      }

      ctx.shadowColor = "transparent";
      ctx.font = `${fontSize}px ${this.config.font}`;
      ctx.fillStyle = this.gradient;
      ctx.textAlign = this.settings.alignment;
      ctx.textBaseline = "middle";
      ctx.fillText(this.config.content, 0, 0);
      ctx.restore();
    }
  }
}
